// ============================================================================
// FNE-BRIDGE Frontend - Constantes applicatives
// ============================================================================

// --- Breakpoints responsive ---
export const BREAKPOINTS = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
} as const;

// --- Dimensions layout ---
export const LAYOUT = {
  SIDEBAR_WIDTH: 260,
  SIDEBAR_COLLAPSED_WIDTH: 64,
  HEADER_HEIGHT: 64,
  FOOTER_HEIGHT: 48,
  CONTENT_MAX_WIDTH: 1440,
  CONTENT_PADDING: 24,
} as const;

// --- Durées d'animation (ms) ---
export const ANIMATION = {
  FAST: 150,
  NORMAL: 300,
  SLOW: 500,
  PAGE_TRANSITION: 200,
} as const;

// --- Z-index ---
export const Z_INDEX = {
  DRAWER: 1200,
  MODAL: 1300,
  SNACKBAR: 1400,
  TOOLTIP: 1500,
} as const;

// --- Formats de date ---
export const DATE_FORMATS = {
  DISPLAY: 'DD/MM/YYYY',
  DISPLAY_TIME: 'DD/MM/YYYY HH:mm',
  API: 'YYYY-MM-DD',
  ISO: 'YYYY-MM-DDTHH:mm:ss.sssZ',
} as const;

// --- Pagination ---
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
} as const;

// --- Messages ---
export const MESSAGES = {
  GENERIC_ERROR: 'Une erreur est survenue. Veuillez réessayer.',
  NETWORK_ERROR: 'Erreur de connexion au serveur. Vérifiez votre connexion internet.',
  SESSION_EXPIRED: 'Votre session a expiré. Veuillez vous reconnecter.',
  UNAUTHORIZED: 'Vous n\'avez pas les droits nécessaires pour cette action.',
  CONFIRM_DELETE: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
  SAVE_SUCCESS: 'Enregistrement effectué avec succès.',
  DELETE_SUCCESS: 'Suppression effectuée avec succès.',
} as const;

// --- LocalStorage keys ---
export const STORAGE_KEYS = {
  AUTH: 'fne-bridge-auth',
  THEME_MODE: 'fne-bridge-theme',
  SIDEBAR_COLLAPSED: 'fne-bridge-sidebar',
  LOCALE: 'fne-bridge-locale',
  RECENT_CONNECTIONS: 'fne-bridge-recent-connections',
} as const;
